/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Message,
  Progress,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import Countdown from '../../components/CountdownAdvance';

const ISOFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export default class AutoReleaseTimer extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    countdownSeconds: PropTypes.number,
    countdownText: PropTypes.string,
    handleCountdownFinish: PropTypes.func,
  }
  static defaultProps = {
    countdownSeconds: 600,
    countdownText: '10 minutes.',
  }
  constructor(props) {
    super(props);
    this.state = {
      showCountdown: true,
      percentage: 0,
    };
  }

  getCountdownFormat = (endTime) => {
    const minutesLeft = moment.duration(moment(endTime).diff(moment())).asMinutes();
    const hoursLeft = moment.duration(moment(endTime).diff(moment())).asHours();
    return {
      day: hoursLeft > 24 ? 'DD' : '',
      hour: minutesLeft > 60 ? 'HH' : '',
      minute: 'MM',
      second: 'SS',
    };
  }
  getPercentage = (partialValue, totalValue) => parseInt((100 * partialValue) / totalValue, 10);
  handleCountdownFinish = () => {
    if (this.props.handleCountdownFinish) this.props.handleCountdownFinish();
  }
  handleOnChangeCountdown = (countdownSeconds, remainingMS) => {
    const remainingSeconds = parseInt(Math.floor(remainingMS * 0.001), 10);
    const newPercentage = 100 - this.getPercentage(remainingSeconds, countdownSeconds);
    if (this.state.percentage !== newPercentage) {
      this.setState({ percentage: newPercentage });
    }
  }
  render() {
    const { countdownSeconds, countdownText, data } = this.props;
    const createdAtMoment = moment.tz(data.createdAt, ISOFormat);
    const endTime = createdAtMoment.clone().add(countdownSeconds, 'seconds');

    if (moment(endTime).unix() > moment(data.createdAt).unix() && moment(endTime).unix() > moment().unix()) {
      return (
        <Message negative style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '0.5em' }}>{countdownText}</p>
          <Progress percent={this.state.percentage} size="tiny" color="red" active>
            <Countdown
              targetDate={moment(endTime, 'ddd, DD MMM YYYY HH:mm:ss ZZ')}
              timeSeparator={' '}
              onFinished={this.handleCountdownFinish}
              format={this.getCountdownFormat(endTime)}
              showLegend
              onChange={remainingMS => this.handleOnChangeCountdown(countdownSeconds, remainingMS)}
            /> remaining
          </Progress>
        </Message>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/AutoReleaseTimer.jsx